import { Tab } from '@headlessui/react';
import React, { useContext, useEffect, useState } from 'react';
import { classNames } from '../../../../utils/helpers/helpers';
import ASPTab from './ASPTab';
import NotASPTab from './NotASPTab';
import { getRejectReasons } from '../../../../services/results/resultsService';
import { useParams } from 'react-router-dom';
import { ExamYearContext } from '../../../../utils/contexts/ExamYearContext';
const TAB_STYLE =
  'w-full border-b-2 p-2 ui-selected:border-b-blue-600 ui-selected:bg-blue-50 ui-selected:text-blue-600';

export default function AcceptedStudents() {
  const [reasons, setReasons] = useState([]);
  const { updateExamYear, yearList } = useContext(ExamYearContext);
  const params = new URLSearchParams(window.location.search);
  const year = params.get('year');
  useEffect(() => {
    getRejectReasons().then((res) => {
      setReasons(res.results);
    });
  }, []);

  useEffect(() => {
    const newYear = yearList.find((y) => y.uuid === year);
    if (newYear) {
      updateExamYear(newYear);
    }
  }, [year, yearList, updateExamYear]);

  return (
    <Tab.Group>
      <div className='flex flex-col'>
        <Tab.List className='flex w-full flex-col font-semibold sm:h-20 sm:flex-row'>
          <Tab className={TAB_STYLE}>
            <span className='flex flex-row items-center justify-center'>
              NOT ASP
            </span>
          </Tab>
          <Tab className={TAB_STYLE}>
            <span className='flex flex-row items-center justify-center'>
              ASP
            </span>
          </Tab>
        </Tab.List>

        <Tab.Panels>
          <Tab.Panel>
            <NotASPTab reasons={reasons} year={year} />
          </Tab.Panel>
          <Tab.Panel>
            <ASPTab reasons={reasons} year={year} />
          </Tab.Panel>
        </Tab.Panels>
      </div>
    </Tab.Group>
  );
}
